import React from 'react';

import styles from './divider.module.css';

export interface DividerProps {
  text?: string;
  style?: React.CSSProperties;
}

export const Divider = ({ text, style }: DividerProps) => (
  <div className={styles?.divider} style={style}>
    {text ? <span className={styles?.divider_inner_text}>{text}</span> : null}
  </div>
);
